export default "__VITE_ASSET__B1sKq9ch__"